import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { CardContainer } from "@/shared/components/CardContainer";
import { MobileHeader } from "@/shared/components/MobileHeader";
import { ResponsiveViewWrapper } from "@/shared/components/ResponsiveViewWrapper";

/** Converts router failures into a safe application-level fallback inside the mobile shell. */
export function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message = isRouteErrorResponse(error)
    ? "نمایش صفحه انجام نشد. لطفاً دوباره تلاش کنید."
    : "یک خطای پیش‌بینی‌نشده رخ داده است.";

  return (
    <ResponsiveViewWrapper
      maxMobileWidth={430}
      className="bg-frame-surface"
      scrollable={false}
      aria-label="خطای سیستمی"
    >
      <MobileHeader
        title="کایرسافت"
        subtitle="خطای سامانه"
        showBack={true}
        backTo="/"
      />

      <div
        className="flex flex-1 flex-col items-center justify-center p-6 text-center select-none"
        dir="rtl"
      >
        <CardContainer
          variant="soft"
          className="w-full space-y-4 py-8 text-center"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 text-red-500">
            <AlertTriangle className="h-7 w-7" aria-hidden="true" />
          </div>
          <div className="space-y-1">
            <span className="text-destructive font-mono text-xs font-bold">
              {status}
            </span>
            <h2 className="text-slate-dark text-base font-bold">
              امکان نمایش این صفحه وجود ندارد
            </h2>
            <p className="text-slate-muted mx-auto max-w-xs text-xs">
              {message}
            </p>
          </div>
          <div className="pt-2">
            <Button
              asChild
              variant="brand"
              size="touch"
              className="w-full text-xs font-bold"
            >
              <Link to="/">بازگشت به صفحه اصلی</Link>
            </Button>
          </div>
        </CardContainer>
      </div>
    </ResponsiveViewWrapper>
  );
}
